module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/line-2@3x.png?1.0.17";